// import axios from "axios"
import firebase from "gatsby-plugin-firebase"

import { LockType, TeamGameResultType, TeamType } from "./types"
import { addDays, startOfWeek } from "date-fns/esm"
// import { nameMapper } from "./name-mapper"
// import { atsRecords as ats } from "./ats-records"
// import Datafiles from "../fb-datafiles"

// async function getGameData(week: string): Promise<{ games: GameType[] }> {
//     if (week.length !== 2) throw "Week must be of format XX (e.g. 02)"

//     const { data }: { data: { games: GameType[] } } = await axios({
//         method: "GET",
//         url: `https://data.ncaa.com/casablanca/scoreboard/football/fbs/2021/${week}/scoreboard.json`,
//         headers: {},
//     })

//     return data
// }

/**
 * DEPRECATED
 */
// export async function getLocks(
//     week: string,
//     year: keyof typeof Datafiles
// ): Promise<LockType[]> {
//     let formattedWeek = week.padStart(2, "0")

//     if (week.length > 2) throw "Badly formatted week input"

//     let data: {
//         games: GameType[]
//     } | null = null

//     // data = await getGameData(week)

//     data =
//         Datafiles[year][
//             `week${formattedWeek}` as keyof typeof Datafiles[typeof year]
//         ]

//     // data = previousGamesData as any

//     let atsRecords: {
//         [x: string]: AtsRecordType
//     } = {}

//     let atsArr = ats.replace(/\n/g, "").split(",")

//     atsArr.forEach((entry, index) => {
//         if (index % 5 !== 0) return
//         atsRecords[entry] = {
//             record: atsArr[index + 1],
//             winPercent: atsArr[index + 2],
//             marginOfVictory: atsArr[index + 3],
//             avgPointsCovered: atsArr[index + 4],
//         }
//     })

//     let results = []

//     let seenGames: { [x: string]: boolean } = {}

//     for (let i = 0; i < atsArr.length; i += 5) {
//         const shortName = nameMapper[atsArr[i] as keyof typeof nameMapper]

//         const currentGame = data?.games.find(({ game }) => {
//             return (
//                 game.home.names.short === shortName ||
//                 game.away.names.short === shortName
//             )
//         })

//         if (!currentGame || !currentGame.game) {
//             continue
//         }

//         if (seenGames[currentGame.game.gameID]) {
//             continue
//         }

//         Object.assign(seenGames, { [currentGame.game.gameID]: true })

//         const currTeamAtsName = atsArr[i]
//         const otherTeamAtsName =
//             currentGame?.game.home.names.short === shortName
//                 ? nameMapper[
//                       currentGame?.game.away.names
//                           .short as keyof typeof nameMapper
//                   ]
//                 : nameMapper[
//                       currentGame?.game.home.names
//                           .short as keyof typeof nameMapper
//                   ]

//         if (!currTeamAtsName || !otherTeamAtsName) {
//             console.log(
//                 `Failed on ${shortName} (index ${i}).  One of the team names is falsy.`
//             )
//             continue
//         }

//         const differential = (
//             parseFloat(atsRecords[currTeamAtsName].winPercent) -
//             parseFloat(atsRecords[otherTeamAtsName].winPercent)
//         ).toFixed(1)

//         const pick =
//             parseFloat(differential) > 0 ? currTeamAtsName : otherTeamAtsName

//         const fade =
//             parseFloat(differential) <= 0 ? currTeamAtsName : otherTeamAtsName

//         results.push({
//             id: currentGame.game.gameID,
//             pick,
//             pickRecord: atsRecords[pick],
//             fade,
//             fadeRecord: atsRecords[fade],
//             differential,
//             gameTime: new Date(
//                 parseInt(currentGame.game.startTimeEpoch + "000")
//             ),
//             timeWithZone: currentGame.game.startTime,
//         })
//     }

//     results.sort(
//         (a, b) => parseFloat(b.differential) - parseFloat(a.differential)
//     )

//     // results.forEach(res =>
//     //     console.log(res.title, colorMessage(parseFloat(res.differential)))
//     // )

//     return results
// }

/**
 *
 * @param date This date will be used to determine the week of the season
 * @returns All matchups from the start date to the end of the week
 */
export async function getFootballLocks(date: Date, maxPrevGames?: number) {
    const matchups = (
        await firebase
            .firestore()
            .collection("cfb-matchups")
            .where("date", ">=", startOfWeek(date).getTime())
            .where("date", "<", addDays(startOfWeek(date), 7).getTime())
            .get()
    ).docs.map(doc => doc.data()) as MatchupType[]

    const teamRecords = (
        await firebase
            .firestore()
            .collection("cfb-teams")
            .get()
    ).docs.map(doc => doc.data()) as TeamType[]

    const results = getFootballStatResults(matchups, teamRecords, maxPrevGames)

    return results
}

/**
 *
 * @param date This date will be used to determine the week of the season
 * @returns All matchups from the start date to the end of the week
 */
export async function getCBBLocks(date: Date, maxPrevGames?: number) {
    const matchups = (
        await firebase
            .firestore()
            .collection("cbb-matchups")
            .where("date", ">=", startOfWeek(date).getTime())
            .where("date", "<", addDays(startOfWeek(date), 7).getTime())
            .get()
    ).docs.map(doc => doc.data()) as MatchupType[]

    const teamRecords = (
        await firebase
            .firestore()
            .collection("cbb-teams")
            .get()
    ).docs.map(doc => doc.data()) as TeamType[]

    const results = getFootballStatResults(matchups, teamRecords, maxPrevGames)

    return results
}

export async function getNFLFootballLocks(date: Date, maxPrevGames?: number) {
    const matchups = (
        await firebase
            .firestore()
            .collection("nfl-matchups")
            .where(
                "date",
                ">=",
                addDays(startOfWeek(addDays(date, -4)), 4).getTime()
            )
            .where(
                "date",
                "<",
                addDays(startOfWeek(addDays(date, -4)), 10).getTime()
            )
            .get()
    ).docs.map(doc => doc.data()) as MatchupType[]

    const teamRecords = (
        await firebase
            .firestore()
            .collection("nfl-teams")
            .get()
    ).docs.map(doc => doc.data()) as TeamType[]

    // const results: LockType[] = []

    const results = getFootballStatResults(matchups, teamRecords, maxPrevGames)

    return results
}

const getFootballStatResults = (
    matchups: MatchupType[],
    teamRecords: TeamType[],
    maxPrevGames?: number
) => {
    const results: LockType[] = []
    for (const matchup of matchups) {
        const homeTeam = teamRecords.find(
            team => team.team === matchup.homeTeam
        )
        const awayTeam = teamRecords.find(
            team => team.team === matchup.awayTeam
        )

        if (!homeTeam || !awayTeam) {
            continue
        }

        const differential = maxPrevGames
            ? getWinPercentDifferential(homeTeam, awayTeam, maxPrevGames)
            : {
                  home: parseFloat(homeTeam.winPercent),
                  away: parseFloat(awayTeam.winPercent),
              }

        const marginDifferential = maxPrevGames
            ? getMarginDifferential(homeTeam, awayTeam, maxPrevGames)
            : {
                  home: parseFloat(homeTeam.avgPointsCovered),
                  away: parseFloat(awayTeam.avgPointsCovered),
              }

        const weightedMarginDifferential = maxPrevGames
            ? getWeightedMarginDifferential(homeTeam, awayTeam, maxPrevGames)
            : getWeightedMarginDifferential(homeTeam, awayTeam, 100)

        results.push({
            id: matchup.id,
            home: homeTeam,
            away: awayTeam,
            winPercent: differential,
            atsMargin: marginDifferential,
            weightedAtsMargin: weightedMarginDifferential,
            gameTime: new Date(matchup.date),
            timeWithZone: "",
        })
    }

    return results
}

type MatchupType = {
    id: string
    awaySpread: number
    awayTeam: string
    date: number
    homeSpread: number
    homeTeam: string
    overUnder: number
}

function getWinPercentDifferential(
    home: TeamType,
    away: TeamType,
    maxPrevGames?: number
) {
    const team1Record = maxPrevGames
        ? home.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .slice(-maxPrevGames)
        : home.results
    const team2Record = maxPrevGames
        ? away.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .slice(-maxPrevGames)
        : away.results

    const team1WinPercent =
        (team1Record.filter(result => parseFloat(result.atsMargin) > 0).length /
            team1Record.length) *
        100
    const team2WinPercent =
        (team2Record.filter(result => parseFloat(result.atsMargin) > 0).length /
            team2Record.length) *
        100

    return { home: team1WinPercent, away: team2WinPercent }
}

function getMarginDifferential(
    home: TeamType,
    away: TeamType,
    maxPrevGames?: number
) {
    const team1Record = maxPrevGames
        ? home.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .slice(-maxPrevGames)
        : home.results
    const team2Record = maxPrevGames
        ? away.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .slice(-maxPrevGames)
        : away.results

    const team1AvgMargin = getMatchupsAvgATSMargin(team1Record)
    const team2AvgMargin = getMatchupsAvgATSMargin(team2Record)

    return { home: team1AvgMargin, away: team2AvgMargin }
}

function getWeightedMarginDifferential(
    home: TeamType,
    away: TeamType,
    maxPrevGames?: number
) {
    const team1Record = maxPrevGames
        ? home.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .filter(
                  (r, _, arr) =>
                      r.gameDateUnix >
                      (arr.at(-1)?.gameDateUnix || 0) -
                          1000 * 60 * 60 * 24 * 160
              )
              .slice(-maxPrevGames)
        : home.results
    const team2Record = maxPrevGames
        ? away.results
              .sort((a, b) => a.gameDateUnix - b.gameDateUnix)
              .filter(
                  (r, _, arr) =>
                      r.gameDateUnix >
                      (arr.at(-1)?.gameDateUnix || 0) -
                          1000 * 60 * 60 * 24 * 160
              )
              .slice(-maxPrevGames)
        : away.results

    const team1AvgMargin = getMatchupsAvgATSMargin(team1Record, {
        weightRecency: true,
    })
    const team2AvgMargin = getMatchupsAvgATSMargin(team2Record, {
        weightRecency: true,
    })

    return { home: team1AvgMargin, away: team2AvgMargin }
}

export const getMatchupsAvgATSMargin = (
    matchups: TeamGameResultType[],
    options?: {
        weightRecency?: boolean
    }
) => {
    let divisor = 0

    const avg =
        matchups.reduce((acc, m, i) => {
            const weight = options?.weightRecency ? i * i + 1 : 1

            divisor += weight

            return (
                acc +
                (isNaN(parseFloat(m.atsMargin))
                    ? 0
                    : parseFloat(m.atsMargin) * weight)
            )
        }, 0) / divisor

    return avg
}
